import { Patient } from 'interfaces';
import { http, HttpResponse } from 'msw';
import { buildPatient } from '../../factories';
import { canonicalPatients } from '../../factories/seeds/entities';
import { mockOrganizations } from './organizationMock';

const organizationByID = new Map(
  mockOrganizations.map((organization) => [organization.id, organization])
);

export const mockPatients: Patient[] = canonicalPatients.map(
  (patient) =>
    buildPatient<Patient>({
      ...patient,
      organization: organizationByID.get(patient.organizationID) ?? null,
    }) as Patient
);

export const patientMockHandlers = [
  http.get('*/resource/patient/organization', ({ request }) => {
    const url = new URL(request.url);
    const page = Number(url.searchParams.get('page')) || 0;
    const pageSize = Number(url.searchParams.get('pageSize')) || 10;
    const globalFilter = url.searchParams.get('globalFilter') || '';
    const base = globalFilter
      ? mockPatients.filter(
          (p) =>
            p.firstName.toLowerCase().includes(globalFilter.toLowerCase()) ||
            p.lastName.toLowerCase().includes(globalFilter.toLowerCase())
        )
      : mockPatients;
    const start = page * pageSize;
    const end = start + pageSize;
    const slice = base.slice(start, end);
    return HttpResponse.json({
      data: slice,
      total: base.length,
      nextPage: page + 1,
      invalidData: [],
    });
  }),

  // single patient by id (?id=)
  http.get('*/resource/patient', ({ request }) => {
    const url = new URL(request.url);
    const id = url.searchParams.get('id');
    const patient = mockPatients.find((p) => p.id === id);
    if (!patient) {
      return HttpResponse.json({ message: 'Not Found' }, { status: 404 });
    }
    return HttpResponse.json(patient);
  }),
];
